import { ReactComponent as IconBirthdayCake } from "./svg/birthday-cake.svg";

export default IconBirthdayCake;
